import React from 'react';
import './CatalogHero.css';
import hero from '../../../assets/hero.png';
import { useLanguage } from '../../../context/LanguageContext';
// Kanka dil hook'unu import ediyoruz

const CatalogHero = () => {
  // t fonksiyonunu çekiyoruz
  const { t } = useLanguage(); 
  
  // Sayfa içi kaydırma fonksiyonu
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="catalog-hero">
      <div className="catalog-hero-container">
        
        <div className="hero-content">
          {/* Badge metni */}
          <div className="hero-badge">{t('catalog.hero.badge')}</div>
          
          <h1 className="hero-title">
            {t('catalog.hero.title1')} <br />
            {t('catalog.hero.title2')} <br />
            <span className="highlight">{t('catalog.hero.highlight')}</span>
          </h1>

          <p className="hero-description">
            {t('catalog.hero.desc')}
          </p>

          <div className="hero-actions">
            <div className="main-actions">
              <button 
                className="btn-primary-green" 
                onClick={() => scrollToSection('category-grid-anchor')}
              >
                {t('catalog.hero.btnGroups')}
              </button>
              
              <button 
                className="btn-outline-gray" 
                onClick={() => scrollToSection('product-list-anchor')}
              >
                {t('catalog.hero.btnSystem')}
              </button>
            </div>

           <button 
              className="btn-black-portfolio" 
              onClick={() => scrollToSection('export-portfolio-anchor')}
            >
              {t('catalog.hero.btnPortfolio')}
            </button>
          </div>

          <div className="hero-certificates">
            {['GMP+', 'ISO 22000', 'ISO 14001', 'ISO 9001', 'OHSAS 18001'].map(cert => (
              <div key={cert} className="cert-pill">{cert}</div>
            ))}
          </div>
        </div>

        <div className="hero-image-wrapper">
          <div className="image-bg-blob"></div>
          <img 
            src={hero} 
            alt="Bigma Dijital Katalog" 
            className="hero-mockup"
          />
        </div>

      </div>
    </section>
  );
};

export default CatalogHero;